// extracted by mini-css-extract-plugin
export default {"user_review":"UserReview_user_review__ZAL9K","review_text":"UserReview_review_text__l7Rhb"};